const isAppleDevice = () => {
	if (typeof navigator === 'undefined') return false;
	const ua = navigator.userAgent || '';
	const isIOS = /iPad|iPhone|iPod/.test(ua);
	const isIpadOS = ua.includes('Mac') && navigator.maxTouchPoints > 1;
	return isIOS || isIpadOS;
};

export default isAppleDevice;
